import { AppLocale } from './config';

export type DimensionTranslationKey =
  | 'positive'
  | 'engagement'
  | 'relationship'
  | 'meaning'
  | 'accomplishment'
  | 'vitality';

export const dimensionTranslationKeys: Record<number, DimensionTranslationKey> = {
  1: 'positive',
  2: 'engagement',
  3: 'relationship',
  4: 'meaning',
  5: 'accomplishment',
  6: 'vitality',
};

export const getDimensionTranslationKey = (dimension: number | string): DimensionTranslationKey | undefined => {
  const numericDimension = Number(dimension);
  return dimensionTranslationKeys[numericDimension];
};

export const getDimensionKeyFromName = (dimension?: string): DimensionTranslationKey | undefined => {
  if (!dimension) return undefined;
  const normalized = dimension.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
  const names: Record<string, DimensionTranslationKey> = {
    POSITIVIDADE: 'positive',
    ENGAJAMENTO: 'engagement',
    ENVOLVIMENTO: 'engagement',
    RELACIONAMENTO: 'relationship',
    SIGNIFICADO: 'meaning',
    REALIZACAO: 'accomplishment',
    VITALIDADE: 'vitality',
  };
  return names[normalized];
};

export const getMonthName = (month: number, locale: AppLocale, short = false): string => {
  if (!Number.isInteger(month) || month < 1 || month > 12) return '';
  return new Intl.DateTimeFormat(locale, { month: short ? 'short' : 'long' }).format(new Date(2020, month - 1, 1));
};

export const formatAnalyticsNumber = (value: number, locale: AppLocale, options?: Intl.NumberFormatOptions): string =>
  new Intl.NumberFormat(locale, options).format(value);

export interface AnalyticsNumberSeparators {
  decimal: string;
  group: string;
}

export const getAnalyticsNumberSeparators = (locale: AppLocale): AnalyticsNumberSeparators => {
  try {
    const parts = new Intl.NumberFormat(locale).formatToParts(1234.5);

    return {
      decimal: parts.find((part) => part.type === 'decimal')?.value || '.',
      group: parts.find((part) => part.type === 'group')?.value || '',
    };
  } catch {
    return { decimal: '.', group: ',' };
  }
};

export const formatAnalyticsPercent = (value: number, locale: AppLocale, maximumFractionDigits = 1): string =>
  formatAnalyticsNumber(value, locale, { minimumFractionDigits: 0, maximumFractionDigits });
